import { getCurrentRef } from '@vista-digital/react-tools';
import { getElementDimensions } from './get-element-dimensions';
const defaultScale = 1;
export function getMinContentScale(viewportRef, contentDimensions) {
    const viewport = getCurrentRef(viewportRef);
    const viewportDimensions = getElementDimensions(viewport, 'content-box');
    const minXScale = Math.floor(viewportDimensions.width) / Math.ceil(contentDimensions.width);
    const minYScale = Math.floor(viewportDimensions.height) / Math.ceil(contentDimensions.height);
    return Math.min(minXScale, minYScale, defaultScale);
}
//# sourceMappingURL=get-min-content-scale.js.map